import { createStructuredSelector } from 'reselect'

import {
   AWARD_DETAIL_LIST,
   AWARD_DETAIL_LIST_SUCCESS, 
   AWARD_DETAIL_LIST_ERROR,
   AWARD_DETAIL_PAGE_SET,
   AWARD_DETAIL_SEARCH_SET,
   AWARD_DETAIL_SEARCH_CHANGE,
   AWARD_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT,
   AWARD_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
   AWARD_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR, 
   AWARD_DETAIL_ADD_SET,
   AWARD_DETAIL_ADD_MODAL_SET,
   AWARD_DETAIL_ADD,
   AWARD_DETAIL_ADD_SUCCESS,
   AWARD_DETAIL_ADD_ERROR,
   AWARD_DETAIL_ADD_CHANGE,
   AWARD_DETAIL_DETAIL,
   AWARD_DETAIL_DETAIL_SUCCESS,
   AWARD_DETAIL_DETAIL_ERROR,
   AWARD_DETAIL_VIEW_MODAL_SET,
   AWARD_DETAIL_EDIT_CHANGE,
   AWARD_DETAIL_EDIT_MODAL_SET,
   AWARD_DETAIL_UPDATE,
   AWARD_DETAIL_UPDATE_SUCCESS,
   AWARD_DETAIL_UPDATE_ERROR,
   AWARD_DETAIL_VIEW_TAB_SET,
   AWARD_DETAIL_UPLOAD_SET,
   AWARD_DETAIL_UPLOAD_SET_SUCCESS,
   AWARD_DETAIL_UPLOAD_SET_ERROR,
   AWARD_DETAIL_UPLOAD_RESET
} from '../actions';

export const AWARD_DETAIL_NAME = 'award_detail';
const NAME = AWARD_DETAIL_NAME;

export const AwardDetailList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type:  AWARD_DETAIL_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const AwardDetailListSuccess = (data) => ({
  type:  AWARD_DETAIL_LIST_SUCCESS,
  payload: data
});

export const AwardDetailListError = (error) => ({
  type:  AWARD_DETAIL_LIST_ERROR,
  payload: error
});

export const AwardDetailPageSet = (data) => ({
  type:  AWARD_DETAIL_PAGE_SET,
  payload: data
});

export const AwardDetailSearchSet = (data) => ({
  type:  AWARD_DETAIL_SEARCH_SET,
  payload: data
});

export const AwardDetailSearchChangeSet = (data) => ({
  type:  AWARD_DETAIL_SEARCH_CHANGE,
  payload: data
});

export const AwardDetailSearchDeliveryOrderLineLot = (data) => ({
  type:  AWARD_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT,
  payload: data
});

export const AwardDetailSearchDeliveryOrderLineLotSuccess = (message) => ({
  type:  AWARD_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
  payload: message
});

export const AwardDetailSearchDeliveryOrderLineLotError = (error) => ({
  type:  AWARD_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR,
  payload: error
}); 

export const AwardDetailAddChangeSet = (data) => ({
  type:  AWARD_DETAIL_ADD_CHANGE,
  payload: data
});

export const AwardDetailAddSet = (data) => ({
  type:  AWARD_DETAIL_ADD_SET,
  payload: data
});

export const AwardDetailAddModalSet = (data) => ({
  type:  AWARD_DETAIL_ADD_MODAL_SET,
  payload: data
});

export const AwardDetailAdd = (data) => ({
  type:  AWARD_DETAIL_ADD,
  payload: data
});

export const AwardDetailAddSuccess = (message) => ({
  type:  AWARD_DETAIL_ADD_SUCCESS,
  payload: message
});

export const AwardDetailAddError = (error) => ({
  type:  AWARD_DETAIL_ADD_ERROR,
  payload: error
});

export const AwardDetailDetail = (data) => ({
  type:  AWARD_DETAIL_DETAIL,
  payload: data
});

export const AwardDetailDetailSuccess = (data, id_award_detail) => ({
  type:  AWARD_DETAIL_DETAIL_SUCCESS,
  payload: data,
  meta: { id_award_detail }
});

export const AwardDetailDetailError = (error, id_award_detail) => ({
  type:  AWARD_DETAIL_DETAIL_ERROR,
  payload: error,
  meta: { id_award_detail }
});

export const AwardDetailViewModalSet = (data) => ({
  type:  AWARD_DETAIL_VIEW_MODAL_SET,
  payload: data
});

export const AwardDetailEditModalSet = (data) => ({
  type:  AWARD_DETAIL_EDIT_MODAL_SET,
  payload: data
});

export const AwardDetailEditChangeSet = (data) => ({
  type:  AWARD_DETAIL_EDIT_CHANGE,
  payload: data
});

export const AwardDetailUpdate = (data) => ({
  type:  AWARD_DETAIL_UPDATE,
  payload: data
});

export const AwardDetailUpdateSuccess = (message) => ({
  type:  AWARD_DETAIL_UPDATE_SUCCESS,
  payload: message.message
});

export const AwardDetailUpdateError = (error) => ({
  type:  AWARD_DETAIL_UPDATE_ERROR,
  payload: error
});

export const AwardDetailViewTabSet = (data) => ({
  type:  AWARD_DETAIL_VIEW_TAB_SET,
  payload: data
});

export const AwardDetailUploadSet = (file) => ({
  type:  AWARD_DETAIL_UPLOAD_SET,
  payload: { file },
});

export const AwardDetailUploadSetSuccess = (items) => ({
  type:  AWARD_DETAIL_UPLOAD_SET_SUCCESS,
  payload: items,
});

export const AwardDetailUploadSetError = (error) => ({
  type:  AWARD_DETAIL_UPLOAD_SET_ERROR,
  payload: error,
});

export const AwardDetailUploadReset= () => ({
  type:  AWARD_DETAIL_UPLOAD_RESET
});

const award_detail = (state) => state[NAME];

export const AwardDetailSelector = createStructuredSelector({
  award_detail
})
 